// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__36czv","rootSmall":"AddTileButton_rootSmall__1t_31"};